module.exports = __webpack_public_path__ + "static/media/500012.83819fb0.svg";